<template src="./system-user-details.html"></template>

<script>
import Vue from 'vue'
import ContextPage from '@/components/context-page/ContextPage'
// import { hasPermissionChangeAuthority } from '@/router/auth.js'
import { EventBus } from '@/router/bus'
import { chain, groupBy, map } from 'lodash'// eslint-disable-line no-unused-vars
import tabulatorMixin from '@/mixins/tabulator'

export default {
  name: 'user-details',
  components: {
    ContextPage
  },
  mixins: [tabulatorMixin],
  data () {
    return {
      loading: false,
      globalUser: false,
      errorCodeSource: 'apiStatusCodes.',
      organizationLink: '',
      userId: 0,
      user: {
        id: this.$route.params.userId
      },
      roles: [],
      roleRules: [
        v => !!v || this.$t('validation.roleRequired')
      ],
      userFormValid: true,
      chipColor: 'grey',
      chipText: '',
      alertShow: false,
      alertType: 'error',
      alertText: '',
      permissionAlertShow: false,
      permissionAlertType: 'error',
      permissionAlertText: '',
      statusAlertShow: false,
      statusAlertType: 'error',
      statusAlertText: '',
      changeSystemUserEnabled: false,
      editSystemUserPrompt: {
        enabled: false,
        loading: false
      },
      revokeSystemUserPrompt: {
        enabled: false,
        loading: false
      },
      activateSystemUserPrompt: {
        enabled: false,
        loading: false
      },
      newComment: '',
      search: '',
      headers: [
        { value: 'data-table-expand', align: 'left', sortable: false },
        { value: 'selected', align: 'left', sortable: false },
        { value: 'localized_name', text: this.$t('systemUsers.roles'), align: 'left', sortable: false },
        { value: 'description', text: this.$t('systemUsers.roleDescription'), align: 'left', sortable: false }
      ],
      currentStatus: 1,
      SystemUserStatus: {
        ACTIVE: 1,
        INACTIVE: 2,
        DISABLED: 3
      },
      status: [
        {
          color: '#52c0a8',
          dark: true,
          text: this.$t('systemUserStatuses.1')
        },
        {
          color: '#CFD8DC',
          dark: false,
          text: this.$t('systemUserStatuses.2')
        },
        {
          color: '#FF5722',
          dark: true,
          text: this.$t('systemUserStatuses.3')
        }
      ],
      nameRules: [
        v => !!v || this.$t('validation.nameRequired')
      ],
      emailRules: [
        v => !!v || this.$t('validation.emailRequired'),
        v => /.+@.+\..+/.test(v) || this.$t('validation.emailRequired')
      ],
      expanded: [],
      availableRoles: [],
      data: []
    }
  },
  created () {
    this.loading = true
    this.userId = this.$route.params.userId
    // get user information by id
    this.$http.get(Vue.$apiConfig.systemUserInformationGet + '/' + this.userId).then(
      response => {
        this.user = response.data.payload
        // get all roles and set selected for the role that user has
        this.$http.get(Vue.$apiConfig.getAllUserRoles).then(
          response => {
            response.data.payload.forEach((role) => {
              this.roles.push({ text: this.$t('roles.' + role.id), value: role.id })
              if (this.user.roleId === role.id) {
                Vue.set(this.user, 'localizedRole', this.$t('roles.' + role.id))
              }
            })
            if (this.roles.filter((role) => { return role.value === this.user.roleId }).length === 0) {
              Vue.set(this.user, 'localizedRole', this.$t('roles.' + this.user.roleId))
              this.roles.push({ value: this.user.roleId, text: this.$t('roles.' + this.user.roleId) })
            }
          },
          error => {
            this.logConsole(error)
            this.roles.push({ text: this.$t('general.noDataAvailable'), value: 0 })
          }
        )
        this.loading = false
      },
      error => {
        this.logConsole(error)
        this.formatErrorResponse(error)
        this.loading = false
      }
    )
  },
  methods: {
    validateSystemUserForm () {
      if (this.$refs.userForm.validate()) {
        this.editSystemUserPrompt.enabled = true
        this.editSystemUser()
      }
    },
    selectRole (selectedRole) {
      this.allRoles.forEach(role => {
        if (selectedRole.id === role.id) {
          role.selected = true
        } else {
          role.selected = false
        }
      })
    },
    editSystemUser () {
      this.logConsole('editProfile to be implemented')
      this.loading = true
      this.$http.post(Vue.$apiConfig.updateSystemUserPost, this.user).then(
        response => {
          EventBus.$emit('alert', {
            variant: 'success',
            message: this.$t('systemUsers.success')
          })
          this.loading = false
          this.editSystemUserPrompt = false
        },
        error => {
          this.logConsole(error)
          this.formatErrorResponse(error)
          this.loading = false
          this.editSystemUserPrompt = false
        }
      )
      this.editSystemUserPrompt.enabled = false
      this.changeSystemUserEnabled = false
    },
    revokeSystemUser () {
      this.loading = true
      this.user.changedComments = this.newComment
      this.$http.post(Vue.$apiConfig.userDisablePost, [this.user])
        .then(response => {
          EventBus.$emit('alert', {
            variant: 'success',
            message: this.$t('systemUsers.statusRestore')
          })
          this.user.status = this.SystemUserStatus.DISABLED
          this.loading = false
          this.revokeSystemUserPrompt = false
        }, error => {
          this.logConsole(error)
          this.formatErrorResponse(error)
          this.loading = false
          this.revokeSystemUserPrompt = false
        })
      this.revokeSystemUserPrompt.enabled = false
    },
    activateSystemUser () {
      this.loading = true
      this.$http.post(Vue.$apiConfig.userEnablePost, [this.user])
        .then(response => {
          EventBus.$emit('alert', {
            variant: 'success',
            message: this.$t('systemUsers.statusActivate')
          })
          this.user.status = this.SystemUserStatus.ACTIVE
          this.loading = false
          this.dialog4 = false
        }, error => {
          this.logConsole(error)
          this.formatErrorResponse(error)
          this.loading = false
          this.dialog4 = false
        })
      this.activateSystemUserPrompt.enabled = false
    }
  }
}
</script>

<style scoped>
  .v-card__text {
    font-size: 15px
  }
  .user-info-type {
    font-size: 16px
  }
  .user-info {
    font-size: 16px;
    font-weight: 600
  }
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }

  .role-popout {
    background-color: #E0F2F1 !important;
  }

  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }

  .centered-label {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
</style>
